

import {
  ADD_TAXONOMY_ERROR, ADD_TAXONOMY_REQUEST, ADD_TAXONOMY_SUCCESS, INPUT_CHANGE,
  INPUT_ERROR, RESET_FORM
} from "./add-taxonomy-action-creators";

const initialState = {
  id: {
    value: "",
    error: "",
    field: "id"
  },
  loading: false
};


export default ( state = initialState, action ) => {

  const { inputName, inputValue, error, field } = action;

  switch(action.type) {

    case RESET_FORM:
      return {
        ...state,
        id: {
          ...state.id,
          value: "",
          error: ""
        }
      };

    case ADD_TAXONOMY_SUCCESS:
    case ADD_TAXONOMY_ERROR:
      return {
        ...state,
        loading: false
      };

    case ADD_TAXONOMY_REQUEST:
      return {
        ...state,
        loading: true
      };

    case INPUT_ERROR:
      return {
        ...state,
        [field]: {
          ...state[field],
          error
        },
        loading: false
      };

    case INPUT_CHANGE:
      return {
        ...state,
        [inputName]: {
          ...state[inputName],
          value: inputValue,
          error: ""
        }
      };

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/modules/add-taxonomy/add-taxonomy-reducer.js